const ConfigActionTypes = {
  GET_CONFIG:    "GET_CONFIG",
  UPDATE_CONFIG: "UPDATE_CONFIG",
};

export default ConfigActionTypes;
